module.exports = __webpack_public_path__ + "media/images/menu-icons/move-b6db712d7abe136bf26d1a34813febac.svg";